import { log as pilog } from "../Logging";
/**
 * Common code for logging API failures
 *
 * @param {object} error
 * @param {string} className
 */
export const handleAPIFailure = (error, className, customerMessage = "", supressLoggingCodes = {}) => {
  let loggerName = "handleSecureAjaxError";
  if (className) {
    loggerName = className;
  }
  let formattedMessage = customerMessage;
  let platformResponse = null;
  let shouldSupressError = false;
  const log = pilog.getLogger(loggerName);
  try {
    if (error.response) {
      const {
        data,
        status,
        statusText,
        config
      } = error.response;

      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (data.code && !supressLoggingCodes[data.code]) {
        log.error(`Platform request failed: ${config.url}`);
        log.error("Platform response %o", data);
        log.error(`Platform HTTP Status ${status} ${statusText}`);
      }
      if (data) {
        platformResponse = data;
        shouldSupressError = supressLoggingCodes[data.code];
      }
      if (status) {
        platformResponse = {
          ...platformResponse,
          "Status Code": status
        };
      }
      if (statusText) {
        platformResponse = {
          ...platformResponse,
          Status: statusText
        };
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      log.error("Platform request error", error);
      formattedMessage = `${formattedMessage} - Unexpected error occurred`;
    } else if (Array.isArray(error.graphQLErrors)) {
      var _graphError$errorInfo;
      const graphError = error.graphQLErrors[0];
      if (!supressLoggingCodes[graphError === null || graphError === void 0 ? void 0 : (_graphError$errorInfo = graphError.errorInfo) === null || _graphError$errorInfo === void 0 ? void 0 : _graphError$errorInfo.code]) {
        log.error("%o", error);
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      log.error("%o", error);
    }
  } catch (error) {
    log.error("Failed to process Error! whoops", error);
  }
  log.debug(`Formatted Message ${formattedMessage}`);
  return {
    platformResponse,
    formattedMessage,
    shouldSupressError
  };
};